import { Outlet } from "react-router";

export default function JoinLayout() {

    return (
        <div className="monitering">
            <Outlet/>
        </div>
    );
}
